.input {
  border: 0;
  padding: 5px 6px;
  background-color: white;
  box-sizing: border-box;
  color: var(--button-text);
  width: 100%;
}

.input:disabled {
  background-color: var(--input-field-disabled);
  color: var(--main-text-disabled);
}
